import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Container } from 'web-ui-components/lib/global/layout';
import { TextStyled } from 'web-ui-components/lib/atoms/text';

const CancelFailureModal = ({ handleClickOk, failureHeader, failureBody, okButtonLabel }) => (
	<Modal isOpen shouldCloseOnOverlayClick={false}>
		<Container className="modal__container u-padding-y-4 u-text-align-center">
			<h3>{failureHeader}</h3>
			{failureBody && <TextStyled size="bute">{failureBody}</TextStyled>}
			<Button className="u-margin-top-2" id="cancel-success-ok" onClick={handleClickOk} width="flush" display="primary">
				{okButtonLabel}
			</Button>
		</Container>
	</Modal>
);

CancelFailureModal.defaultProps = {
	failureHeader: 'Something went wrong.',
};
CancelFailureModal.propTypes = {
	failureHeader: PropTypes.string,
	failureBody: PropTypes.string,
	okButtonLabel: PropTypes.string.isRequired,
	handleClickOk: PropTypes.func.isRequired,
};
export default CancelFailureModal;
